import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

export default function LORStandings({ api }) {
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${api}/api/lor/standings`)
      .then(r => r.json())
      .then(data => { setStandings(data || []); setLoading(false); })
      .catch(e => { setError('Failed to load standings.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Loading standings...</div>;
  if (error)   return <div className="lor-empty">{error}</div>;

  const isPreSeason = standings.every(s => s.wins === 0 && s.losses === 0);

  return (
    <div className="lor-standings-page">
      <div className="lor-page-header">
        <h2 className="lor-page-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon emoji="🏆" size={18} /> Standings</h2>
        <div className="lor-page-meta">
          {isPreSeason
            ? 'Pre-Season — Draft has not started yet'
            : `${standings.length} teams · Full PPR · SuperFlex`}
        </div>
      </div>

      {isPreSeason && (
        <div className="lor-preseason-banner">
          <Icon emoji="⚡" size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> The 2026 season has not started. Standings will populate once games are played.
        </div>
      )}

      <div className="lor-card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="lor-standings-table">
          <thead>
            <tr>
              <th style={{ width: 36 }}>RK</th>
              <th>Manager</th>
              <th>W</th>
              <th>L</th>
              <th>T</th>
              <th>PF</th>
              <th>PA</th>
              <th>Win%</th>
              <th>Streak</th>
            </tr>
          </thead>
          <tbody>
            {standings.map(s => (
              <tr
                key={s.roster_id}
                className={s.rank <= 4 ? 'lor-playoff-spot' : ''}
              >
                <td className="lor-rank">
                  {s.rank}
                  {s.rank === 4 && (
                    <span className="lor-bubble-line" title="Playoff bubble"></span>
                  )}
                </td>
                <td className="lor-manager-cell">
                  {s.avatar && (
                    <img
                      src={`https://sleepercdn.com/avatars/thumbs/${s.avatar}`}
                      alt={s.display_name}
                      className="lor-avatar"
                    />
                  )}
                  <div>
                    <div className="lor-manager-name">{s.display_name}</div>
                    {s.team_name && s.team_name !== s.display_name && (
                      <div className="lor-team-name">{s.team_name}</div>
                    )}
                  </div>
                </td>
                <td className="lor-wins">{s.wins}</td>
                <td className="lor-losses">{s.losses}</td>
                <td className="lor-stat">{s.ties}</td>
                <td className="lor-pf">{s.pf}</td>
                <td className="lor-stat">{s.pa}</td>
                <td className="lor-stat">{(s.win_pct * 100).toFixed(1)}%</td>
                <td className={`lor-streak lor-streak--${(s.streak?.type || 'w').toLowerCase()}`}>
                  {s.streak?.count > 0 ? `${s.streak.type}${s.streak.count}` : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="lor-standings-legend">
        <span className="lor-legend-dot lor-legend-dot--playoff"></span> Playoff spot (top 4)
      </div>
    </div>
  );
}
